import { Box, Flex, styled, Text } from '@grupoboticario/flora-react';

const styles = {
  CreditWrapper: styled(Box, {
    width: '100%',
  }),

  InfoWrapper: styled(Flex, {
    width: '100%',
  }),

  ProgressValues: styled(Flex, {
    flexWrap: 'wrap',
    gap: '$1',

    '@mobile': {
      flexWrap: 'nowrap',
    },
  }),

  ResellerId: styled('span', {
    marginLeft: '$1',
  }),

  ResellerName: styled(Text, {
    textTransform: 'capitalize',
  }),

  Wrapper: styled(Flex, {
    flexWrap: 'wrap',

    '@tablet': {
      flexWrap: 'nowrap',
    },
  }),
};

export default styles;
